export default __webpack_public_path__ + "static/producthunt-ba3fcc4fac234cd5fe0fd164619b79f8.png";